import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ROUTER_LINKS } from '../consts/app-keys.const';

interface UpgradeModalProps {
  message: string;
  onClose: () => void;
}

export const UpgradeModal = ({ message, onClose }: UpgradeModalProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-[3px]">
      <div className="bg-white dark:bg-[#1C1C1F] rounded-[20px] shadow-xl px-[32px] py-[28px] w-full mx-[20px] max-w-[420px]">
        <div className="flex items-center gap-[10px] mb-[12px]">
          <span className="w-[36px] h-[36px] rounded-full bg-[#F8FCFF] dark:bg-[#28282B] border border-[#BCEBFB] dark:border-[rgba(255,255,255,0.08)] flex items-center justify-center flex-shrink-0">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0ea5c9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
              <polyline points="17 6 23 6 23 12" />
            </svg>
          </span>
          <h2 className="font-display text-[18px] font-bold text-base-black dark:text-white">
            {t('upgrade.title')}
          </h2>
        </div>
        <p className="font-body text-[14px] text-[#4A4A4C] dark:text-[#A0A0A3] mb-[20px] leading-relaxed">
          {message}
        </p>
        <div className="flex gap-[10px]">
          <button
            type="button"
            onClick={() => {
              onClose();
              navigate(ROUTER_LINKS.PRICING);
            }}
            className="flex-1 h-[44px] rounded-[32px] bg-base-black dark:bg-[#C8C8CB] text-white dark:text-[#1C1C1F] font-body text-[14px] font-medium hover:bg-[#2E2E30] dark:hover:bg-[#D8D8DB] transition-all"
          >
            {t('upgrade.viewPlans')}
          </button>
          <button
            type="button"
            onClick={onClose}
            className="h-[44px] px-[20px] rounded-[32px] border border-gray-500 dark:border-[rgba(255,255,255,0.08)] bg-gray-400 dark:bg-[#28282B] font-body text-[14px] font-medium text-base-black dark:text-white hover:bg-[#E0E0E3] dark:hover:bg-[#333336] transition-all"
          >
            {t('common.cancel')}
          </button>
        </div>
      </div>
    </div>
  );
};
